import React, { Component } from 'react';


export const GetResults = async (batchNo) => {
    console.log("taha")
     return fetch(`api/Results/GetResults/${batchNo}`)
        .then(handleResponse)

        .then(response => response.json())
         
  
}
export const GetMedicalResults = async (batchNo) => {
    //console.log("taha")
    return fetch(`api/Results/GetMedicalResults/${batchNo}`)
        .then(handleResponse)

        .then(response => response.json())


}
export const AllowViewResults = async (batchNo) => {
    return fetch(`api/Results/AllowViewResults/${batchNo}`)
       .then(handleResponse)

       .then(response => response.text())
        
 
}

export const GetStudentFacCode = async () => {
    return fetch(`api/Results/GetStudentFac`)
        .then(handleResponse)
        .then(response => response.text())

}

export const GetGPA = async (batchNo) => {
     return fetch(`api/Results/LoadGPA/${batchNo}`)
        .then(handleResponse)

        .then(response => response.json())


}
export const GetBatches = async () => {
     return fetch('api/Results/Batches')
        .then(handleResponse)

        .then(response => response.json())

}

export const GetLastTermCourses = async () => {
     return fetch('api/Results/GetLastTermCourses')
        .then(handleResponse)

        .then(response => response.json())

}

const handleResponse = (response) => {

    if (!response.ok) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            console.log(this.props)
            window.location = "http://www.google.com"
        }


        return Promise.reject();
    }
    return Promise.resolve(response)


}




// WEBPACK FOOTER //
// ./src/pages/results/API.js